/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CaretRight: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M11 1L22 12L11 23' stroke='currentColor' fill='transparent' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' />
  </React.Fragment>
)
